module.exports = __webpack_public_path__ + "static/media/dataa.3fbb5494.jpg";